export class PasswordHintRequest {
    email: string;

    constructor(email: string) {
        this.email = email;
    }
}
